
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import VacanciesEventsCards from '~/components/vacancies/events-block/VacanciesEventsCards.vue';

export default BaseCmsBlock.extend({
  name: 'LatestEventBlock.vue',
  components: {
    VacanciesEventsCards,
  },
  computed: {
    localValues: function () {
      return this.externalData?.LatestEventBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
    localExtras: function () {
      return this.extras || {};
    },
  },
})
